import SEOPageTemplate from '../components/SEOPageTemplate';

const HourlyChauffeur = () => (
  <SEOPageTemplate
    city="Hourly & As-Directed"
    state="East Coast"
    route="/hourly-as-directed-chauffeur"
    imageSrc="/hourly-limo.jpg"
    services={[
      'Luxury chauffeur service for hourly and as-directed bookings',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Boston ⇄ NYC, DC ⇄ Philadelphia',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur for hourly hire',
      'Best chauffeur for as-directed service',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service hourly',
      'Best executive car service for hourly bookings',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Logan International Airport (BOS)',
      'JFK',
      'LGA',
      'DCA',
      'Newark Liberty International Airport (EWR)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Sheltair'
    ]}
    neighborhoods={[
      'Boston',
      'New York',
      'Washington DC',
      'Philadelphia',
      'All major East Coast cities'
    ]}
  />
);

export default HourlyChauffeur; 